<template>
  <div>
      <div class="login-box">
      <div class="login-logo "><h2 class="text-white">Django-Advanced-Chat</h2></div>
      <div class="login-box-body">
        <p class="login-box-msg">Войдите в чат</p>

        <form method="post"  @submit.prevent="login" class="form-element">
          <div class="form-group has-feedback">
            <input type="text" class="form-control" placeholder="Имя пользователя" v-model="userModel.username" required>
            <span class="ion ion-email form-control-feedback"></span>
            <span  class="error-field text-danger" v-show="error" v-for="error in fieldErrors('username')" :key="error">{{ error }}</span>
          </div>
          <div class="form-group has-feedback">
            <input type="password" class="form-control" placeholder="Пароль" v-model="userModel.password" required>
            <span class="ion ion-locked form-control-feedback"></span>
            <span  class="error-field text-danger" v-show="error" v-for="error in fieldErrors('password')" :key="error">{{ error }}</span>
          </div>
          <div class="row">
            <div class="col-md-6">
             <div class="fog-pwd">
                <a href="/password_reset"><i class="ion ion-locked"></i> Забыли пароль?</a><br>
              </div>
            </div>
            <!-- /.col -->
            <div class="col-12 text-center">
              <div class=" alert alert-danger form-errors" role="alert" v-show="error" v-for="error in fieldErrors('non_field_errors')" :key="error">
                {{ error }}
              </div>
            </div>
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-info btn-block btn-flat margin-top-10">Войти</button>
            </div>
            <!-- /.col -->
          </div>
        </form>

        <div class="margin-top-30 text-center">
          <p>Ещё нет аккаунта? <a href="/signup" class="text-info m-l-5">Зарегистрироваться</a></p>
        </div>

      </div>
      <!-- /.login-box-body -->
    </div>
      <!-- /.login-box -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
require('../assets/vendor_components/Ionicons/css/ionicons.min.css');
require('../assets/vendor_components/font-awesome/css/font-awesome.min.css');
require('../assets/css/master_style.min.css');

export default {
  data () {
    return {
      userModel: {username: '', password: ''},
      agree: true,
      agree_error: false,
      error: false,
    }
  },
  computed:{
    ...mapState('auth', ['errors']),
  },
  methods: {
    login() {
        let username = this.userModel.username
        let password = this.userModel.password
        this.$store.dispatch('auth/login', { username, password })
    },
    fieldErrors: function (field) {
      if (field in this.errors) {
        return this.errors[field]
      }
      return []
    }
  }

}
</script>

<style scoped>
  #auth-container {
    margin-top: 50px;
  }

  .tab-content {
    padding-top: 20px;
  }
  .error-field{
    color: #fc4b6c;
  }
</style>
